import React, { forwardRef } from "react";
import classNames from "classnames";
const DrawerPaneActions = forwardRef(({ actions, showActions = Boolean(actions) }, ref) => {
    const hasActionsToShow = actions && showActions;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: ref, className: classNames("drawer-panel-actions", {
                "has-content": hasActionsToShow,
            }) },
            React.createElement("div", null, hasActionsToShow && actions))));
});
DrawerPaneActions.displayName = "DrawerPaneActions";
export default DrawerPaneActions;
//# sourceMappingURL=DrawerPaneActions.js.map